module.exports = __webpack_public_path__ + "static/media/percentBtn.12372c27.png";